import StaticTranslations from './../../assets/static-translations'

export default class StaticTranslator {

  constructor () {
    let systemLangArray = navigator.language.split('-')

    this.language = systemLangArray[0]
  }

  /**
   *
   * @param text
   * @return {*}
   */
  translate (text) {
    return StaticTranslations[this.language][text]
  }

}
